module.exports = [{
      plugin: require('/zeit/351d06eb/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
